module.exports = __webpack_public_path__ + "img/galery21.1c705523.jpg";